import { SET_LOADING } from './mutations';
import { DEFINE_LOADING } from './actions';


export default {
  state: {
    loading: false,
  },
  getters: {
    loading: state => state.loading,
  },
  mutations: {
    [SET_LOADING](state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    [DEFINE_LOADING](context, payload) {
      context.commit(SET_LOADING, payload.loading);
    },
  },
};
